module.exports = __webpack_public_path__ + "static/ma-044b2c6ba02000d9b199050a5cb8d7da.png";